const VUE_APP_USER_URL = document.querySelector("html").getAttribute("api_user_url");

export default VUE_APP_USER_URL
